/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Col_ToolInputs */

const en_pc_alt_col_tool = /** @type {(inputs: Pc_Alt_Col_ToolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool`)
};

const zh_pc_alt_col_tool = /** @type {(inputs: Pc_Alt_Col_ToolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具`)
};

/**
* | output |
* | --- |
* | "Tool" |
*
* @param {Pc_Alt_Col_ToolInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_col_tool = /** @type {((inputs?: Pc_Alt_Col_ToolInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Col_ToolInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_col_tool(inputs)
	return zh_pc_alt_col_tool(inputs)
});
export { pc_alt_col_tool as "pc.alt.col.tool" }